module.exports = __webpack_public_path__ + "img/central-klaus-2.c8ea4d31.png";